module.exports = __webpack_public_path__ + "img/videowall_large.9299a938.webp";